// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import Select from 'react-select';
// import './filter.scss';
// import DualRangeSlider from 'components/range/rangeSlider';
// import { fetchIndicators } from 'store/filterSlice';

// const timePeriodOptions = [
//   { value: 'all', label: 'All' },
//   { value: 'range', label: 'Custom' },
//   // { value: 'custom', label: 'Custom' },
// ];

// const datasetOptions = [
//   { value: 'ds1', label: 'Dataset 1' },
//   { value: 'ds2', label: 'Dataset 2' },
//   { value: 'ds3', label: 'Dataset 3' },
// ];

// const ministryOptions = [
//   'Ministry of Health',
//   'Ministry of Education',
//   'Ministry of Housing',
// ];

// const geoLevelMap = {
//   1: 'National',
//   2: 'State',
//   3: 'District',
//   4: 'ULB',
// };

// const VerticalFilterBar = ({ indicatorData }) => {
//   const dispatch = useDispatch();
//   console.log(indicatorData,"indicatorData");
//   const { indicators } = useSelector((state) => state.filter);

//   const [searchTerm, setSearchTerm] = useState('');
//   const [timePeriod, setTimePeriod] = useState('all');
//   const [rangeValue, setRangeValue] = useState(50);
//   const [customStart, setCustomStart] = useState('');
//   const [customEnd, setCustomEnd] = useState('');
//   const [customStartYear, setCustomStartYear] = useState(2011);
//   const [customEndYear, setCustomEndYear] = useState(2025);
//   const [geoLevel, setGeoLevel] = useState([]);
//   const [geoOptionsState, setGeoOptionsState] = useState([]);
//   const [selectedDatasets, setSelectedDatasets] = useState([]);
//   const [selectedMinistries, setSelectedMinistries] = useState([]);

//   // Populate geo level options from indicators and cache them
//   useEffect(() => {
//     if (indicatorData && indicatorData.length > 0) {
//       const levels = Array.from(
//         new Set(indicatorData.flatMap((indicator) => indicator.geo_levels))
//       ).map((level) => ({
//         value: level,
//         label: geoLevelMap[level] || `Level ${level}`,
//       }));

//       setGeoOptionsState(levels);
//     }
//   }, [indicatorData]);

//   const handleApply = () => {
//     const payload = {
//       search: searchTerm.trim(),
//       time_period: timePeriod,
//       year_range: timePeriod === 'range' ? [customStartYear, customEndYear] : [],
//       custom_years: timePeriod === 'custom' ? [customStart, customEnd] : [],
//       geo_levels: geoLevel.map((g) => parseInt(g.value)),
//       datasets: selectedDatasets.map((ds) => ds.value),
//       ministries: selectedMinistries,
//       sector_codes: Array.from(
//         new Set(indicatorData.map((ind) => ind.sector_code))
//       ),
//     };

//     console.log('Filter Payload:', payload);
//     dispatch(fetchIndicators(payload));
//   };

//   const handleReset = () => {
//     setSearchTerm('');
//     setTimePeriod('all');
//     setRangeValue(50);
//     setCustomStart('');
//     setCustomEnd('');
//     setGeoLevel([]);
//     setSelectedDatasets([]);
//     setSelectedMinistries([]);
//   };

//   return (
//     <div className="filter-container">
//       <div className="filter-bar p-3 bg-white shadow-sm">
//         <h5 className="mb-3">Filters</h5>

//         {/* Search */}
//         {/* <input
//           type="text"
//           className="form-control mb-3"
//           placeholder="Search indicators..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         /> */}

//         {/* Time Period */}
//         <label className="form-label">Time Period</label>
//         <div className="mb-3">
//           {timePeriodOptions.map((opt) => (
//             <div key={opt.value} className="form-check">
//               <input
//                 type="radio"
//                 className="form-check-input"
//                 name="timePeriod"
//                 id={`tp-${opt.value}`}
//                 value={opt.value}
//                 checked={timePeriod === opt.value}
//                 onChange={() => setTimePeriod(opt.value)}
//               />
//               <label className="form-check-label" htmlFor={`tp-${opt.value}`}>
//                 {opt.label}
//               </label>
//             </div>
//           ))}

//           {timePeriod === 'range' && <DualRangeSlider />}
//           {timePeriod === 'custom' && (
//             <div className="mt-2 d-flex gap-2">
//               <input
//                 type="text"
//                 className="form-control"
//                 placeholder="Start"
//                 value={customStart}
//                 onChange={(e) => setCustomStart(e.target.value)}
//               />
//               <input
//                 type="text"
//                 className="form-control"
//                 placeholder="End"
//                 value={customEnd}
//                 onChange={(e) => setCustomEnd(e.target.value)}
//               />
//             </div>
//           )}
//         </div>

//         {/* Geo Level */}
//         <label className="form-label">Granularity</label>
//         <Select
//           isMulti
//           options={geoOptionsState}
//           value={geoLevel.filter((g) =>
//             geoOptionsState.some((opt) => opt.value === g.value)
//           )}
//           onChange={setGeoLevel}
//           placeholder="Select geo levels..."
//           className="mb-3"
//         />

//         {/* Ministry Checkboxes */}
//         <label className="form-label">Ministry</label>
//         <div className="mb-3">
//           {ministryOptions.map((min, index) => (
//             <div key={index} className="form-check">
//               <input
//                 type="checkbox"
//                 className="form-check-input"
//                 id={`ministry-${index}`}
//                 checked={selectedMinistries.includes(min)}
//                 onChange={() =>
//                   setSelectedMinistries((prev) =>
//                     prev.includes(min)
//                       ? prev.filter((m) => m !== min)
//                       : [...prev, min]
//                   )
//                 }
//               />
//               <label className="form-check-label" htmlFor={`ministry-${index}`}>
//                 {min}
//               </label>
//             </div>
//           ))}
//         </div>

//         {/* Dataset */}
//         <label className="form-label">Dataset</label>
//         <Select
//           isMulti
//           options={datasetOptions}
//           value={selectedDatasets}
//           onChange={setSelectedDatasets}
//           placeholder="Select datasets..."
//         />
//       </div>

//       {/* Bottom Buttons */}
//       <div className="filter-actions d-flex justify-content-between p-3 bg-light">
//         <button className="btn btn-primary btn-sm" onClick={handleApply}>
//           Apply
//         </button>
//         <button className="btn btn-outline-secondary btn-sm" onClick={handleReset}>
//           Reset
//         </button>
//       </div>
//     </div>
//   );
// };

// export default VerticalFilterBar;



// components/filter/verticalfilter.jsx

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import './filter.scss';
import DualRangeSlider from 'components/range/rangeSlider';
import { fetchIndicators } from 'store/filterSlice';
import { useParams } from "react-router-dom";



const timePeriodOptions = [
  { value: 'all', label: 'All' },
  { value: 'range', label: 'Custom' },
];



const ministryOptions = [
  'Ministry of Health',
  'Ministry of Education',
  'Ministry of Housing',
];
const geoLevelMap = {
  National: "National",
  state: "State / UT",
  district: "District ",
  city: "City ",
  // Add other mappings here...
};
// const geoLevelMap = {
//   1: 'National',
//   2: 'State',
//   3: 'District',
//   4: 'ULB',
// };

const VerticalFilterBar = ({ indicatorData, onFilterApply, filterMetaData, filterState, setFilterState }) => {
  const dispatch = useDispatch()
  const { indicators } = useSelector((state) => state.filter);
  const { id } = useParams();
  const [searchTerm, setSearchTerm] = useState('');
  // const [timePeriod, setTimePeriod] = useState('all');
  // const [rangeValue, setRangeValue] = useState(50);
  // const [customStart, setCustomStart] = useState('');
  // const [customEnd, setCustomEnd] = useState('');
  // const [customStartYear, setCustomStartYear] = useState(2011);
  // const [customEndYear, setCustomEndYear] = useState(2025);
  // const [geoLevel, setGeoLevel] = useState([]);
  const [geoOptionsState, setGeoOptionsState] = useState([]);
  // const [selectedDatasets, setSelectedDatasets] = useState([]);
  // const [selectedMinistries, setSelectedMinistries] = useState([]);
  // Destructure filter state
  const {
    timePeriod,
    customStartYear,
    customEndYear,
    customStart,
    customEnd,
    geoLevel,
    selectedDatasets,
    selectedMinistries
  } = filterState;

  const datacode = filterMetaData?.sectors?.map(data => data?.code) || [];
  useEffect(() => {
    if (indicatorData && indicatorData.length > 0) {
      const levels = Array.from(
        new Set(indicatorData.flatMap((indicator) => indicator.geo_levels))
      ).map((level) => ({
        value: level,
        label: geoLevelMap[level] || ` ${level}`,
      }));

      setGeoOptionsState(levels);
    }
  }, [indicatorData]);

  const handleApply = () => {
    const payload = {
      search: searchTerm.trim(),
      years: timePeriod === 'range'
        ? [customStartYear, customEndYear]
        : timePeriod === 'custom'
          ? [customStart, customEnd]
          : [],
      geo_levels: geoLevel.map((g) => parseInt(g.value)),
      dataset_ids: selectedDatasets.map((ds) => ds.value),
      agency_code: selectedMinistries,
      sector_codes: id ? [id] : datacode

    };
    dispatch(fetchIndicators(payload))
      .unwrap()
      .then((filteredIndicators) => {
        if (onFilterApply) onFilterApply(filteredIndicators);
      })
      .catch((err) => {
        console.error("Error fetching filtered indicators:", err);
      });
  };
  const updateFilterState = (updates) => {
    setFilterState(prev => ({ ...prev, ...updates }));
  };

  const handleReset = () => {
    setSearchTerm('');
    setFilterState({
      timePeriod: 'all',
      customStartYear: 2011,
      customEndYear: 2025,
      customStart: '',
      customEnd: '',
      geoLevel: [],
      selectedDatasets: [],
      selectedMinistries: []
    });
    
    // Fetch complete indicator list with empty filters
    const resetPayload = {
      search: '',
      years: [],
      geo_levels: [],
      dataset_ids: [],
      agency_code: [],
      sector_codes: id ? [id] : datacode
    };
    
    dispatch(fetchIndicators(resetPayload))
      .unwrap()
      .then((filteredIndicators) => {
        if (onFilterApply) onFilterApply(filteredIndicators);
      })
      .catch((err) => {
        console.error("Error fetching indicators on reset:", err);
      });
  };

  return (
    <div className="filter-container">
      <div className="filter-bar p-3 bg-white shadow-sm">
        <h5 className="mb-3">Filters</h5>

        {/* Time Period */}
        <label className="form-label">Time Period</label>
        <div className="mb-3">
          {timePeriodOptions.map((opt) => (
            <div key={opt.value} className="form-check">
              <input
                type="radio"
                className="form-check-input"
                name="timePeriod"
                id={`tp-${opt.value}`}
                value={opt.value}
                checked={timePeriod === opt.value}
                onChange={() => updateFilterState({ timePeriod: opt.value })}
              />
              <label className="form-check-label" htmlFor={`tp-${opt.value}`}>
                {opt.label}
              </label>
            </div>
          ))}
          {timePeriod === 'range' && (
            <DualRangeSlider
              minYear={customStartYear}
              maxYear={customEndYear}
              setMinYear={(year) => updateFilterState({ customStartYear: year })}
              setMaxYear={(year) => updateFilterState({ customEndYear: year })}
            />
          )}
          {timePeriod === 'custom' && (
            <div className="mt-2 d-flex gap-2">
              <input
                type="text"
                className="form-control"
                placeholder="Start"
                value={customStart}
                onChange={(e) => updateFilterState({ customStart: e.target.value })}
              />
              <input
                type="text"
                className="form-control"
                placeholder="End"
                value={customEnd}
                onChange={(e) => updateFilterState({ customEnd: e.target.value })}
              />
            </div>
          )}
        </div>

        {/* Geo Level */}
        <label className="form-label">Geographic Granularity</label>
        <Select
          isMulti
          options={
            filterMetaData?.geo_levels?.map(ds => ({
              value: ds.code,
              label: ds.name
            })) || []}
          value={geoLevel}
          onChange={(value) => updateFilterState({ geoLevel: value })}
          placeholder="Select geo levels..."
          className="mb-3"
          menuPortalTarget={document.body}
          menuPosition='fixed'
        />

        {/* Ministry Checkboxes */}
        <label className="form-label">Ministry / Agency / Lead body</label>
        <div className="mb-3">
          {[...new Map(indicatorData?.map(item => [item.agency_name, item])).values()]
            .map((min, index) => (
              <div key={index} className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`ministry-${index}`}
                  checked={selectedMinistries.includes(min.agency_code)}
                  onChange={() =>
                    updateFilterState({
                      selectedMinistries: selectedMinistries.includes(min.agency_code)
                        ? selectedMinistries.filter((m) => m !== min.agency_code)
                        : [...selectedMinistries, min.agency_code]
                    })
                  }
                />
                <label className="form-check-label" htmlFor={`ministry-${index}`}>
                  {min.agency_name}
                </label>
              </div>
            ))}

        </div>
        {/* Dataset */}
        <label className="form-label">Dataset</label>
        <Select
          isMulti
          options={
            filterMetaData?.dataset_name?.map(ds => ({
              value: ds.code,
              label: ds.name
            })) || []
          }
          value={selectedDatasets}
          onChange={(value) => updateFilterState({ selectedDatasets: value })}
          placeholder="Select datasets..."
          menuPortalTarget={document.body}
          menuPosition='fixed'
        />
      </div>

      <div className="filter-actions d-flex justify-content-between p-3 bg-light">
        <button className="btn btn-primary btn-sm" onClick={handleApply}>
          Apply
        </button>
        <button className="btn btn-outline-secondary btn-sm" onClick={handleReset}>
          Reset
        </button>
      </div>
    </div>
  );
};

export default VerticalFilterBar;

